import React, {useState} from 'react'
import {Button, Form, Input, Modal, Select} from "antd";
import {updateCustomer, getCustomerById} from "../../services/serviceCustomer";
import config from "../../config";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const {TextArea} = Input
const {Option} = Select

const CustomerEdit = ({customer, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleEditClick = () => {
        getCustomerById(customer.id)
            .then(({data}) => {
                form.setFieldsValue({
                    customerName: data.name,
                    customerSector: data.sector,
                    customerTaxNo: data.taxNo,
                    customerTaxOffice: data.taxOffice,
                    customerWebSite: data.website,
                    customerMobilePhone: data.mobilePhone,
                    customerInternalPhone: data.internalPhone,
                    customerEmail: data.email,
                    customerFax: data.fax,
                    customerDescription: data.description,
                    cargoCompany: data.cargoCompany
                })
            })
        setEditModal(!editModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)

        let request = {
            id: customer.id,
            name: list.customerName,
            description: list.customerDescription,
            email: list.customerEmail,
            mobilePhone: list.customerMobilePhone,
            taxNo: list.customerTaxNo,
            taxOffice: list.customerTaxOffice,
            internalPhone: list.customerInternalPhone,
            sector: list.customerSector,
            fax: list.customerFax,
            website: list.customerWebSite,
            cargoCompany: list.cargoCompany
        }
        updateCustomer(request)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch( () => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Button type={'link'} onClick={()=>handleEditClick()}>Güncelle</Button>

            <Modal
                open={editModal}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button type={'primary'} loading={loadings[0]}  key={'SubmitButton'} onClick={()=> form.submit()}>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() =>handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={'Müşteri Adı'}
                        name={'customerName'}
                        rules={[
                            {required:true, message:'İsim Alanı Boş Bırakılamaz'},
                            {min:5, max:300, message:'İsim Alanı En Az 5, En Fazla 300 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Sektör'}
                        name={'customerSector'}
                        rules={[
                            {max:50, message: 'Sektör Alanı En Fazla 50 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Vergi No'}
                        name={'customerTaxNo'}
                        rules={[
                            {min:10, max:11, message: 'Vergi No Alanı En Az 10 En Fazla 11 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Dairesi'}
                        name={'customerTaxOffice'}
                        rules={[
                            {max:50, message: 'Vergi Dairesi En Fazla 50 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Web Sitesi'}
                        name={'customerWebSite'}
                        rules={[
                            {max: 100, message: 'Web Sitesi En Fazla 100 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Cep Telefonu'}
                        name={'customerMobilePhone'}
                        rules={[
                            {max: 20, message: 'Cep Telefonu En Fazla 20 Karakter Olmalı'},
                            {pattern: /^\d*$/, message: 'Cep Telefonu Sadece Rakam İçermelidir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Sabit Hat'}
                        name={'customerInternalPhone'}
                        rules={[
                            {max: 20, message: 'Sabit Hat En Fazla 20 Karakter Olmalı'},
                            {pattern: /^\d*$/, message: 'Sabit Hat Sadece Rakam İçermelidir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Email'}
                        name={'customerEmail'}
                        rules={[
                            {type: 'email', message:'Doğru bir E-mail Formatı Girilmelidir (örnek@örnek.com)'},
                            {max: 100, message: 'E-mail Alanı En Fazla 100 Karakterden Oluşmalıdır'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Fax'}
                        name={'customerFax'}
                    >
                        <Input  />
                    </Form.Item>
                    <Form.Item
                        label={'Kargo Şirketi'}
                        name={'cargoCompany'}
                    >
                        <Select>
                            {
                                config.cargoOptions.map((item, index) => <Option key={index} value={item}>{item}</Option>)
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={'Not'}
                        name={'customerDescription'}
                        rules={[
                            {max: 500, message: 'Not Alanı En Fazla 500 Karakterden Oluşmalıdır'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default CustomerEdit